import React from "react";
import { useExtrasCategoriesFlag } from "../../../application/hooks/useExtrasCategoriesFlag";
import { ExtraCategoryFields } from "./ExtraCategoryFields";

interface ExtraCategoryInputsProps {
  /** AGR child copy: shown read-only, like the rest of the form. */
  disabled: boolean;
}

/** Category fields of the extra page, only when the property's flag is on. */
export function ExtraCategoryInputs({ disabled }: ExtraCategoryInputsProps) {
  const active = useExtrasCategoriesFlag();
  return active ? <ExtraCategoryFields disabled={disabled} /> : null;
}
